import { useEffect } from "react";

const useAddReviewModal = (
  ref: React.RefObject<HTMLElement>,
  onOutsideClick: () => void,
  isActive: boolean,
): void => {
  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (ref.current && !ref.current.contains(event.target as Node)) {
        onOutsideClick();
      }
    };

    if (isActive) {
      document.addEventListener("mousedown", handleClickOutside);
    }

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [ref, onOutsideClick, isActive]);
};

export default useAddReviewModal;
